import React from 'react';
import { styled } from '@mui/system';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingBlock = styled('div')({
    position: 'absolute',
    backgroundColor: '#c0c0c040',
    top: '0px',
    bottom: '0px',
    left: '0px',
    right: '0px',
    zIndex: 2,
    textAlign: 'center',
    paddingTop: '70px',
});

const Loading = () => {
    return (
        <LoadingBlock>
            <CircularProgress color="secondary" size={50} />
        </LoadingBlock>
    );
};
export default Loading;
